<template>
  <div class="infinity-select" ref="infinitySelect">
    <InfinitySelectPreview
      v-model="selected"
      @on-change="onSelectedChanged"
      @on-delete-selected="onDeleteSelected"
    ></InfinitySelectPreview>
    <div
      v-if="listEmpty"
      class="infinity-select-options-wrapper-null"
      ref="listEmpty"
    >
      暂无数据
    </div>
    <div
      v-else
      class="infinity-select-options-wrapper"
      ref="infinitySelectOptionsWrapper"
    >
      <div class="infinity-select-options" @click="onClickOption"></div>
    </div>
  </div>
</template>
<script>
import InfinitySelectPreview from "./Preview.vue";
import BScroll from "@better-scroll/core";
import MouseWheel from "@better-scroll/mouse-wheel";
import InfinityScroll from "@better-scroll/infinity";

BScroll.use(InfinityScroll);
BScroll.use(MouseWheel);
let IScroll;
export default {
  name: "InfinitySelect",
  components: {
    InfinitySelectPreview,
  },
  props: {
    multiple: Boolean,
    value: [Array, String],
    fetchMethod: Function,
    placeholder: String,
  },
  data() {
    return {
      visible: false,
      selected: [],
      fetchFinished: false,
      listEmpty: true,
    };
  },
  computed: {
    nullList() {
      return this.list.length === 0;
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          if (this.$refs.infinitySelectOptionsWrapper)
            this.setDefaultSelected(newValue);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.firstFetch();
  },
  beforeDestroy() {
    window.removeEventListener("click", this.toggleOptionsWrapper);
  },
  methods: {
    firstFetch() {
      this.fetchMethod().then(({ data, finished }) => {
        if (!data || data.length === 0) {
          // 首次请求无数据
          this.listEmpty = true;
        } else {
          this.listEmpty = false;
          this.$nextTick(() => {
            this.genScroll({
              data,
              finished,
            });
          });
        }
        window.addEventListener("click", this.toggleOptionsWrapper);
      });
    },
    genScroll(firstData) {
      IScroll = new BScroll(this.$refs.infinitySelectOptionsWrapper, {
        mouseWheel: true,
        click: true,
        infinity: {
          fetch: () => {
            return new Promise((resolve) => {
              if (firstData.data && firstData.data.length > 0) {
                this.setOptionsWrapperHeight(firstData.data);
                this.fetchFinished = firstData.finished;
                resolve(firstData.data);
                firstData.data = null;
              } else {
                if (this.fetchFinished) {
                  console.log("加载完毕，停止滚动");
                  resolve(false);
                } else {
                  this.fetchMethod().then(({ data, finished }) => {
                    if (data && data.length > 0) {
                      // 有数据
                      this.setOptionsWrapperHeight(data);
                      // 高度设置完毕需要刷新滚动
                      IScroll.refresh();
                      this.fetchFinished = finished;
                      resolve(data);
                    } else {
                      this.$refs.infinitySelectOptionsWrapper.style.height =
                        "100px";
                      // 高度设置完毕需要刷新滚动
                      IScroll.refresh();
                      this.fetchFinished = true;
                      resolve([]);
                    }
                  });
                }
              }
            });
          },
          render: (item, div) => {
            const el = div || document.createElement("div");
            el.classList.add("infinity-select-options-item");
            el.dataset.value = item.value;
            el.dataset.label = item.label;
            el.title = item.label;
            el.innerText = item.label;
            let checkedEl = el.children[0];
            if (!checkedEl) {
              checkedEl = document.createElement("img");
              checkedEl.src = require("./images/checked.svg");
              checkedEl.classList.add("checked-icon");
              el.append(checkedEl);
            }
            if (this.value.includes(item.value)) {
              this.selected.push(item);
            }
            return el;
          },
          createTombstone: () => {
            const el = document.createElement("div");
            const i = document.createElement("i");
            el.classList.add("infinity-select-options-item", "tombstone");
            el.append(i);
            return el;
          },
        },
      });
    },
    onClickOption(e) {
      if (this.multiple) {
        const hadTargetIndex = this.selected.findIndex(
          (item) => item.value === e.target.dataset.value
        );
        // 选中效果
        e.target.classList.toggle("checked");
        if (hadTargetIndex > -1) {
          this.selected.splice(hadTargetIndex, 1);
        } else {
          this.selected.push({
            label: e.target.dataset.label,
            value: e.target.dataset.value,
          });
        }
      } else {
        if (!e.target.classList.contains("checked")) {
          const nodeList = e.target.parentNode.querySelectorAll(
            ".infinity-select-options-item"
          );
          for (let i = 0; i < nodeList.length; i++) {
            if (nodeList[i].classList.contains("checked")) {
              nodeList[i].classList.remove("checked");
              break;
            }
          }
          e.target.classList.add("checked");
          this.selected = [
            {
              label: e.target.dataset.label,
              value: e.target.dataset.value,
            },
          ];
        } else {
          e.target.classList.remove("checked");
          this.selected = [];
        }
      }
      this.onSelectedChanged(this.selected);
    },
    onDeleteSelected(item) {
      const target = this.$refs.infinitySelectOptionsWrapper.querySelector(
        `[data-value="${item.value}"]`
      );
      target.classList.remove("checked");
    },
    toggleOptionsWrapper(e) {
      if (this.$refs.infinitySelect.contains(e.target)) {
        if (this.listEmpty) {
          this.$refs.listEmpty.classList.add("visible");
        } else {
          if (this.multiple) {
            if (!this.$refs.infinitySelectOptionsWrapper.contains(e.target)) {
              this.$refs.infinitySelectOptionsWrapper.classList.toggle(
                "visible"
              );
            }
          } else {
            this.$refs.infinitySelectOptionsWrapper.classList.toggle("visible");
          }
        }
      } else {
        if (this.listEmpty) {
          this.$refs.listEmpty.classList.remove("visible");
        } else {
          this.$refs.infinitySelectOptionsWrapper.classList.remove("visible");
        }
      }
    },
    setDefaultSelected(value) {
      if (this.multiple) {
        this.selected = [];
        value.forEach((item) => {
          const domTarget =
            this.$refs.infinitySelectOptionsWrapper.querySelector(
              `[data-value="${item}"]`
            );
          if (domTarget) {
            domTarget.classList.add("checked");
            this.selected.push({
              label: domTarget.dataset.label,
              value: domTarget.dataset.value,
            });
          }
        });
      } else {
        this.selected = [];
        const domTarget = this.$refs.infinitySelectOptionsWrapper.querySelector(
          `[data-value="${value}"]`
        );
        if (domTarget) {
          domTarget.classList.add("checked");
          this.selected = [
            {
              label: domTarget.dataset.label,
              value: domTarget.dataset.value,
            },
          ];
        }
      }
    },
    onSelectedChanged(selected) {
      if (this.multiple) {
        this.$emit(
          "input",
          selected.map((item) => item.value),
          JSON.parse(JSON.stringify(selected))
        );
        this.$emit(
          "on-change",
          selected.map((item) => item.value),
          JSON.parse(JSON.stringify(selected))
        );
      } else {
        if (selected[0]) {
          this.$emit(
            "input",
            selected[0].value,
            JSON.parse(JSON.stringify(selected[0]))
          );
          this.$emit(
            "on-change",
            selected[0].value,
            JSON.parse(JSON.stringify(selected[0]))
          );
        } else {
          this.$emit("input", "", undefined);
          this.$emit("on-change", "", undefined);
        }
      }
      this.$parent.$emit("on-form-change");
    },
    setOptionsWrapperHeight(list) {
      const height = Math.min(200, list.length * 25);
      this.$refs.infinitySelectOptionsWrapper.style.height = height + "px";
    },
  },
};
</script>
<style lang="stylus" scoped>
.infinity-select
  position relative
  width 100%

  >>>.ivu-dropdown
    width 100%

  .infinity-select-options-wrapper, .infinity-select-options-wrapper-null
    width 100%
    position absolute
    top 38px
    background-color #fff
    border-radius 4px
    box-shadow 0 1px 6px rgba(0, 0, 0, .2)
    overflow hidden
    visibility hidden
    background #fff
    z-index 999

    &.visible
      visibility visible

  .infinity-select-options-wrapper-null
    padding 30px
    text-align center
    color #999

  .infinity-select-options-wrapper
    .infinity-select-options
      width 100%

      >>>.infinity-select-options-item
        position relative
        padding 0px 30px 0px 10px
        line-height 25px
        cursor pointer
        font-size 13px
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        width 100%
        height 25px

        &:hover
          background #f5f5f5

        .checked-icon
          display none
          position absolute
          width 14px
          right 10px
          top 50%
          transform translateY(-50%)

        &.checked
          .checked-icon
            display block
</style>
